import { useState, useLayoutEffect, useMemo } from "react"
import { useLocation, useNavigate, useOutletContext } from "react-router-dom"
import { useAuth } from "contexts/auth-context"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import { lang } from "config"
import Form from "./form"
import { insertPurchaseReturnFromReceipt } from "helpers/transaction-helper" // ✅ buat helper ini

export default function CreatePurchaseReturn({ title }) {
  const { user, currentBranch } = useAuth()
  const { cache } = useSWRConfig()
  const { setTransition } = usePage()
  const { setTitle } = useOutletContext()

  const location = useLocation()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
    setTitle(`Create Purchase Return`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = (payload) => {
    // payload dari FormCreate: { receipt_id, outlet_id?, return_date?, reason? }
    const onSuccess = (result, message) => {
      nProgress.done()
      cache?.clear?.()

      toast.success(message || "Return draft berhasil dibuat!", { id: "submit" })

      const newId = result?.data?.id || result?.id
      if (newId) {
        navigate(`/purchase-returns/${newId}/edit`, {
          replace: true,
          state: { back: title, from: location.pathname, transition: "slide" },
        })
      } else {
        navigate({ pathname: "/purchase-returns" })
      }
    }

    const onError = (message) => {
      nProgress.done()
      toast.error(message || "Gagal buat return", { id: "submit" })
    }

    // Validasi minimal di container
    if (!payload?.receipt_id) {
      setErrors({
        receipt_id: "Goods Receipt " + lang.field_required,
      })
      return
    }

    const outletId = payload?.outlet_id ?? currentBranch?.id

    nProgress.start()
    toast.loading("Memuat...", { id: "submit" })

    insertPurchaseReturnFromReceipt(
      payload.receipt_id,
      {
        outlet_id: outletId,
        return_date: payload?.return_date,
        reason: payload?.reason,
      },
      user?.name,
      onSuccess,
      onError
    )
  }

  const defaultData = useMemo(
    () => ({
      outlet_id: currentBranch?.id ?? null,
      return_date: null,
      reason: "",
      receipt_id: null,
    }),
    [currentBranch?.id]
  )

  return (
    <Transition type="fade">
      <Form data={defaultData} errors={errors} onSubmit={handleSubmit} />
    </Transition>
  )
}